import { memo } from "react";
import { MoreOutlined } from "@ant-design/icons";
import { Button, Popover, Skeleton, Space } from "antd";
import { useSelector } from "react-redux";
import {
  isDesktopLayoutSelector,
  loadedInitSelector,
} from "appredux/selectors";
import ProfileMenu from "./ProfileMenu";
import CompanySelector from "./CompanySelector";
import LaguangeSelector from "./LanguageSelector";
import OnlineStatus from "./OnlineStatus";
import StreamChatSwitch from "./StreamChatSwitch";

const AgentStatusBarSkeleton = () => (
  <span className="inline-flex items-center align-middle leading-none">
    <Skeleton.Input
      active
      size="small"
      className="!w-[min(260px,72vw)] !max-w-full !min-w-[120px] !m-0 shrink-0"
      style={{ height: 22, verticalAlign: "middle" }}
    />
  </span>
);

const AgentStatusControls = () => {
  const loadedInit = useSelector(loadedInitSelector);

  if (!loadedInit) {
    return <AgentStatusBarSkeleton />;
  }

  return (
    <div className="inline-flex flex-col items-start gap-3 py-0.5">
      <div className="w-fit max-w-full flex items-center">
        <OnlineStatus />
      </div>
      <div className="w-fit max-w-full flex items-center">
        <StreamChatSwitch />
      </div>
    </div>
  );
};

const TopBar = () => {
  const isDesktopLayout = useSelector(isDesktopLayoutSelector);
  const loadedInit = useSelector(loadedInitSelector);

  return (
    <div className="flex flex-row justify-between items-center w-full">
      <Space size="middle" align="center" className="flex items-center">
        {isDesktopLayout ? (
          <div className="flex min-h-8 flex-row flex-nowrap items-center gap-4 leading-none">
            {loadedInit ? (
              <>
                <OnlineStatus />
                <StreamChatSwitch />
              </>
            ) : (
              <AgentStatusBarSkeleton />
            )}
          </div>
        ) : (
          <Popover
            trigger="click"
            placement="bottomLeft"
            content={<AgentStatusControls />}
          >
            <Button
              type="text"
              icon={<MoreOutlined className="text-lg" />}
              aria-label="Status online dan stream chat"
            />
          </Popover>
        )}
      </Space>

      <Space size="middle">
        <CompanySelector />
        <LaguangeSelector />
        <ProfileMenu />
      </Space>
    </div>
  );
};

const Component = memo(TopBar);

export default Component;
